import { type ReactNode } from 'react';
import { cn } from './cn';

type Tone =
  | 'neutral'
  | 'brand'
  | 'emerald'
  | 'rose'
  | 'amber'
  | 'sky';

const TONE: Record<Tone, string> = {
  neutral:
    'bg-surface-muted text-ink-muted border border-line',
  brand:
    'bg-brand-500/10 text-brand-700 border border-brand-500/25',
  emerald:
    'bg-success-soft/60 text-success-ink border border-success/25',
  rose:
    'bg-danger-soft/60 text-danger-ink border border-danger/25',
  amber:
    'bg-warning-soft/60 text-warning-ink border border-warning/25',
  sky:
    'bg-info-soft/60 text-info-ink border border-info/25',
};

interface BadgeProps {
  tone?: Tone;
  children: ReactNode;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  className?: string;
  size?: 'xs' | 'sm';
}

export function Badge({
  tone = 'neutral',
  children,
  leftIcon,
  rightIcon,
  className,
  size = 'xs',
}: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium tracking-tight',
        size === 'xs' && 'px-2 py-0.5 text-xs',
        size === 'sm' && 'px-2.5 py-1 text-xs',
        TONE[tone],
        className,
      )}
    >
      {leftIcon}
      {children}
      {rightIcon}
    </span>
  );
}
